<script>
	import '@fontsource-variable/inter';
	import '@fontsource-variable/source-serif-4/opsz.css';
	import '@fontsource-variable/source-serif-4/opsz-italic.css';
	import '../app.css';
	import Header from '$lib/components/common/Header.svelte';
	import Footer from '$lib/components/common/Footer.svelte';
	import { ProgressBar } from '@prgm/sveltekit-progress-bar';
	import { page } from '$app/stores';
</script>

<ProgressBar class="text-accent-600" />

{#if $page.url.pathname.includes('/read')}
	<slot />
{:else}
	<div class="flex min-h-screen flex-col">
		<Header />

		<main class="flex-1">
			<slot />
		</main>

		<Footer />
	</div>
{/if}
